import React, { useEffect, useState } from "react";
import moment from "moment";
import contractService from "../../../services/contract/contractService";
import { BeatLoader } from "react-spinners";
import { useHistory, useLocation } from "react-router";
const ContractList = () => {
  const isLogged = JSON.parse(localStorage.getItem("user"));
  const history = useHistory();
  const location = useLocation();
const [list, setList] = useState([]);
const [dataValue, setDataValue] = useState([]);
const [contractCarte, setContractCarte] = useState(null);
const motCle = "AssurMax";

useEffect(() => {
  const fetchData = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) return;

      const response = await contractService.getAllContractsByCustomer(user.id);
      const contracts = response.data;
      setList(contracts);
      const foundContract = contracts.find(el => el.family.includes(motCle));

      if (foundContract) {
        setContractCarte(foundContract);
        const res = await contractService.getvalueinfobyidcontract(foundContract.idcontract);
        
        if (res.status === 200) {
          setDataValue(res.data);
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  fetchData();
}, []);
  
  return (
    <div className="body-sinistre">
      <h4
        style={{
          font: "normal normal bold 25px/27px Century Gothic",
          color: "#0C015F",
        }}
      >
        Mes objets assurés
      </h4>
     { isLogged?.token ?  <div className="tab-scroll">
        <div className="row col-md-12 tab-sinistres margin0">
          <div className="row col-md-12 tab-container">
            <div className="col-md-2 col-lg-2 col-sm-2 col-2">
              <h6 className="title-tab">N° contrat/ Formule/ Marque</h6>
            </div>
            <div className="col-md-2 col-lg-2 col-sm-2 col-2">
              <h6 className="title-tab">Date d'effet</h6>
            </div>
            <div className="col-md-2 col-lg-2 col-sm-2 col-2">
              <h6 className="title-tab">Date d'échéance</h6>
            </div>
            <div className="col-md-2 col-lg-2 col-sm-2 col-2">
              <h6 className="title-tab">Modèle</h6>
            </div>
            <div className="col-md-2 col-lg-2 col-sm-2 col-2">
              <h6 className="title-tab">Produit</h6>
            </div>
            <div className="col-md-2 col-lg-2 col-sm-2 col-2">
              <h6 className="title-tab">État</h6>
            </div>
          </div>
          {list.length != 0 ? (
            list?.map((el, key) => {
              if (el.status === "AP" && el.canalVente == "web")
                return (
                  <div className="row col-md-12 row-tab">
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">{el.formattedName}</h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.startDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">{moment(el.endDate).format("DD/MM/yyyy")}</h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family == "Optique" ? el.marque : el.model}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family}
                      </h6>
                    </div>
                    <div
                      className="col-md-2 col-lg-2 col-sm-2 col-2"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h6
                        className="value-tab"
                        style={{ marginRight: "5px", width: "fit-content" }}
                      >
                        En attente de paiement
                      </h6>
                      <div
                        className="boule-couleur"
                        style={{ backgroundColor: "#029AD9" }}
                      ></div>
                    </div>
                  </div>
                );
              if (el.status === "E")
                return (
                  <div className="row col-md-12 row-tab">
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">{el.formattedName}</h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.startDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.endDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family == "Optique" ? el.marque : el.model}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family}
                      </h6>
                    </div>
                    <div
                      className="col-md-2 col-lg-2 col-sm-2 col-2"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h6
                        className="value-tab"
                        style={{ marginRight: "5px", width: "fit-content" }}
                      >
                        Expiré
                      </h6>
                      <div
                        className="boule-couleur"
                        style={{ backgroundColor: "#EEE501" }}
                      ></div>
                    </div>
                  </div>
                );
              if (el.status === "V" || el.canalVente === "Distributeur")
                return (
                  <div className="row col-md-12 row-tab">
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">{el.formattedName}</h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.startDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.endDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family == "Optique" ? el.marque : el.model}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family}
                      </h6>
                    </div>
                    <div
                      className="col-md-2 col-lg-2 col-sm-2 col-2"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h6
                        className="value-tab"
                        style={{ marginRight: "5px", width: "fit-content" }}
                      >
                        Validé
                      </h6>
                      <div
                        className="boule-couleur"
                        style={{ backgroundColor: "#26876B" }}
                      ></div>
                    </div>
                  </div>
                );
              if (el.status == "AS")
                return (
                  <div className="row col-md-12 row-tab">
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">{el.formattedName}</h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.startDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {moment(el.endDate).format("DD/MM/yyyy")}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family == "Optique" ? el.marque : el.model}
                      </h6>
                    </div>
                    <div className="col-md-2 col-lg-2 col-sm-2 col-2">
                      <h6 className="value-tab">
                        {el.family}
                      </h6>
                    </div>
                    <div
                      className="col-md-2 col-lg-2 col-sm-2 col-2"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h6
                        className="value-tab"
                        style={{ marginRight: "5px", width: "fit-content" }}
                      >
                        En attente de signature
                      </h6>
                      <div
                        className="boule-couleur"
                        style={{ backgroundColor: "#029AD9" }}
                      ></div>
                    </div>
                  </div>
                );
            })
          ) : (
            <div style={{ textAlign: "center" }}>
              <img width="100" src="/assets/images/dash-1.svg" />
              <h3>Vous n'avez pas encore de contrat d'assurance actif</h3>
            </div>
          )}
        </div>
      </div> : 
       <div className="row col-md-8 testwidth">
          <div>
          </div>
      {dataValue?.map((ele, index) => (
        <div className="product-card" key={index}>
          <div className="card-header-flex">
            {/* Icône du smartphone à gauche */}
            <div className="product-icon">
              <img  src={
                        `${process.env.PUBLIC_URL}/assets/images/` +
                        ele.productName +
                        ".svg"
                      } alt={ele.productName} />
            </div>

            <div className="product-details">
              <h4 className="product-title">
                <span className="blue-icon"></span> {ele.productName}
              </h4>
              
              {/* On filtre les paramètres textuels uniquement ici */}
              <div className="details-grid">
                {ele.value_info_list
                  .filter(el => !["photoAv", "photoAr", "video"].includes(el.parameter))
                  .map((el, indx) => (
                    <p key={indx}><strong>{el.parameter} :</strong> {el.value}</p>
                  ))}
              </div>
            </div>
          </div>

          {/* Section des boutons en bas à droite */}
          <div className="card-actions">
            {ele.value_info_list.map((el, indx) => {
              if (el.parameter === "photoAv") {
                return <a href={el.value} className="btn-action btn-blue" key={indx}>📷 Photo AV</a>;
              }
              if (el.parameter === "photoAr") {
                return <a href={el.value} className="btn-action btn-blue" key={indx}>📷 Photo AR</a>;
              }
              if (el.parameter === "video") {
                return <a href={el.value} className="btn-action btn-blue-dark" key={indx}>📹 Vidéo</a>;
              }
              return null;
            })}
          </div>
        </div>
      ))}
          <div>
            <button
              type="button"
              class="btn btn-primary btn-annuler"
              onClick={() => history.goBack()}
            >
              Retour
            </button>
          </div>
        </div>}
    </div>
  );
};
export default ContractList;
